import React from "react";
import { Navigate } from "react-router-dom";
import {
  Paper,
  Stack,
  Image,
  Title,
  Text,
  Button,
  Alert,
  rem,
  Box,
} from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";
import { useAuth } from "../../context/AuthContext";
import { getDefaultRoute } from "../../config/routes";
import rNameLogo from "../../assets/Reppi.svg";

function CompanyAssignmentPage() {
  const { user, logout, authLoading } = useAuth();

  const handleLogout = async () => {
    await logout();
  };

  // Admins aren't company-scoped, so this gate never applies to them - send
  // them on even if they land here directly.
  if (!authLoading && user?.isAdmin) {
    return <Navigate to={getDefaultRoute(true, user)} replace />;
  }

  return (
    <Box
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "var(--color-bg-primary)",
        padding: "20px",
      }}
    >
      <Paper
        shadow="lg"
        radius="lg"
        p="xl"
        w="100%"
        maw={500}
        style={{
          background: "var(--color-bg-card)",
          border: "1px solid var(--color-border-extra-light)",
        }}
      >
        <Stack align="center" gap="xl">
          {/* Logo Section */}
          <Image src={rNameLogo} alt="Reppi" h={60} fit="contain" />

          {/* Title */}
          <Title order={1} ta="center" size="h2" fw={700}>
            Company Assignment Required
          </Title>

          {/* Message Content */}
          <Stack gap="md" w="100%">
            <Text ta="center" c="dimmed" size="md">
              Sorry, you aren't currently assigned to a company. To access the
              platform, you need to be associated with a company account.
            </Text>

            <Text ta="center" c="dimmed" size="md">
              Please reach out to your manager and have them add you to your
              company's account.
            </Text>

            {/* User Info Alert */}
            {user && (
              <Alert
                icon={<IconInfoCircle size={rem(16)} />}
                variant="light"
                radius="md"
              >
                <Stack gap="xs">
                  <Text size="sm" fw={500}>
                    Your Account: {user.email}
                  </Text>
                  <Text size="sm" fw={500}>
                    Rep ID: {user.repId}
                  </Text>
                </Stack>
              </Alert>
            )}
          </Stack>

          {/* Action Section */}
          <Stack align="center" gap="md" w="100%">
            <Text ta="center" c="dimmed" size="sm">
              Need help? Contact your system administrator or manager to get
              assigned to a company.
            </Text>

            <Button variant="outline" size="md" onClick={handleLogout}>
              Sign Out
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Box>
  );
}

export default CompanyAssignmentPage;
